export const organizeMealsWithGifs = meals => {
  const [withGifs, mealsList] = meals.reduce(
    (result, meal) => {
      result[!!meal.gif && meal.stock > 0 ? 0 : 1].push(meal)
      return result
    },
    [[], []]
  )
  if (withGifs.length > 0) {
    let prevPos = 0
    withGifs.forEach((meal, idx) => {
      const nextPos = nextGifPosition(prevPos, idx)
      mealsList.splice(nextPos - 1, 0, meal)
      prevPos = nextPos
    })
  }
  return mealsList
}

//Frequency of: 5,7,7,5,7,7..
const nextGifPosition = (prevPos, index) =>
  index % 3 === 0 ? prevPos + 5 : prevPos + 7

export const isBundle = meal => !!meal.meals

export const trackingProductType = product => {
  const isBundleProduct = isBundle(product)
  return isBundleProduct
    ? 'Bundle'
    : product.category_id === 3
    ? 'Meal'
    : 'Add-on'
}
